import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {PaywallHostComponent} from './paywall-host/paywall-host.component';
import {PaywallModalComponent} from './paywall-modal/paywall-modal.component';
import {PaymentMethodChoiceComponent} from './payment-method-choice/payment-method-choice.component';
import {CompanyRequisitesFormComponent} from './company-requisites-form/company-requisites-form.component';
import {CompanyRequisitesModalComponent} from './company-requisites-modal/company-requisites-modal.component';
import {TariffExpansionBuilderComponent} from './tariff-expansion-builder/tariff-expansion-builder.component';

/**
 * Загружается eagerly в AppModule, чтобы paywall-модалка могла открыться на любой странице
 * при 402-ответе. Компоненты в PaymentModule (UsageIndicator, FeedbackSurvey, InvoicePage)
 * остаются в lazy-модуле — они нужны только внутри /payment.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
  ],
  declarations: [
    PaywallHostComponent,
    PaywallModalComponent,
    PaymentMethodChoiceComponent,
    CompanyRequisitesFormComponent,
    CompanyRequisitesModalComponent,
    TariffExpansionBuilderComponent,
  ],
  exports: [
    PaywallHostComponent,
    PaywallModalComponent,
    PaymentMethodChoiceComponent,
    CompanyRequisitesFormComponent,
    CompanyRequisitesModalComponent,
    TariffExpansionBuilderComponent,
  ],
})
export class PaywallModule {
}
